/* eslint-disable no-console */
import { TRACKER_LOG } from './config';

let outputAlreadyBefore = false;

export const logger = new Proxy(console, {
  get(target, prop, receiver) {
    if (!TRACKER_LOG) {
      return () => {};
    }

    if (!outputAlreadyBefore) {
      outputAlreadyBefore = true;
      console.log(
        '🎯 You opted in to output the tracking log to the console. Look for the emoji on this line to identify any tracking related output.',
      );
    }

    if (
      prop === 'log' ||
      prop === 'error' ||
      prop === 'warn' ||
      prop === 'debug' ||
      prop === 'info'
    ) {
      return (message: any, ...args: unknown[]) => {
        if (typeof message === 'string') {
          message = `🎯 ${message}`;
        }

        target[prop].apply(target, [message, ...args]);
      };
    }

    // if (prop === 'table') {
    //   return (data: any, props: string[] | undefined) => {
    //     let firstKey = Object.keys(data)[0];
    //     if (data[firstKey] === '') {
    //       data[firstKey] = `🎯 ${data[firstKey]}`
    //       data = {
    //         '🎯': '',
    //         ...data,
    //       }
    //     }
    //     target[prop].apply(target, [data, props]);
    //   }
    // }

    if (typeof prop === 'string' && prop in target) {
      return (...args: unknown[]) =>
        (target[prop as keyof Console] as (...args: unknown[]) => unknown).apply(target, args);
    }

    return () => {};
  },
});
